import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { Icon, Grid } from "semantic-ui-react";
import auth from "../../services/authService";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { saveEntryType } from "../../services/projectLedgerService";

//const LedgerNetBalance = (props) => {

class LedgerProjectNetBalance extends Component {
  projectUpdate = async (id) => {
    var selectedValue = document.getElementById("entry_type" + id).value;

    const verifyData = {
      selectedValue: selectedValue,
      id: id,
    };

    try {
      await saveEntryType(verifyData);
      toast.success("Entry Type has been updated successfully.");
    } catch (ex) {
      if (ex.response && ex.response.status === 422) {
        // toast.warning("Hours should be only numbers");
      }
    }
  };

  render() {
    const {
      visa,
      payments,
      onDelete,
      onUpdate,
      visaid,
      totalDailyHours,
      totalAmount,
      totalMaterialExpense,
      totalExpense,
      totalDebit,
      totalCredit,
      totalReceiveableAmount,
      totalRunningInvoices,
    } = this.props;

    var url = "/projects/" + visaid + "/document/new/";

    let netBalance = 0;
    let receiveable = 0;

    let tME = parseFloat(totalMaterialExpense).toFixed(2);
    let tE = parseFloat(totalExpense).toFixed(2);
    let tR = parseFloat(totalRunningInvoices).toFixed(2);

    return (
      <Table celled>
        <Table.Row>
          <Table.Cell colspan="12" style={{ backgroundColor: "#eeeeee" }}>
            <Grid columns={3} divided>
              <Grid.Row>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={6}>Client / Company Name</Table.Cell>
                        <Table.Cell>{visa.company_name}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Email</Table.Cell>
                        <Table.Cell>{visa.email}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Mobile/Tel1</Table.Cell>
                        <Table.Cell>{visa.mobile_tel}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Mobile/Tel2</Table.Cell>
                        <Table.Cell>{visa.mobile_tel1}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={6}>Consultant Name</Table.Cell>
                        <Table.Cell>{visa.consultant_name}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Consultant Email</Table.Cell>
                        <Table.Cell>{visa.consultant_email}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Consultant Phone1</Table.Cell>
                        <Table.Cell>{visa.consultant_phone1}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={6}>Consultant Phone2</Table.Cell>
                        <Table.Cell>{visa.consultant_phone2}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
                <Grid.Column>
                  <Table definition>
                    <Table.Body>
                      <Table.Row>
                        <Table.Cell width={5}>Project Name</Table.Cell>
                        <Table.Cell>{visa.project_name}</Table.Cell>
                      </Table.Row>

                      <Table.Row>
                        <Table.Cell width={5}>Ref Date</Table.Cell>
                        <Table.Cell>{visa.ref_date}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={5}>Project Code</Table.Cell>
                        <Table.Cell>{visa.project_code}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={5}>Work Order</Table.Cell>
                        <Table.Cell>{visa.work_order}</Table.Cell>
                      </Table.Row>
                      <Table.Row>
                        <Table.Cell width={5}>TRN</Table.Cell>
                        <Table.Cell>{visa.trn}</Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.HeaderCell
            width={2}
            style={{
              textAlign: "center",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Date
          </Table.HeaderCell>
          <Table.HeaderCell
            width={4}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Description
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Daily Hours
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{ height: "40px", backgroundColor: "#ddd" }}
          >
            Rate
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{ height: "40px", backgroundColor: "#ddd" }}
          >
            Amount
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Expense
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Total Expense
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Running Invoices
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{ height: "40px", backgroundColor: "#ddd" }}
          >
            Debit
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{ height: "40px", backgroundColor: "#ddd" }}
          >
            Credit
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{
              whiteSpace: "pre-line",
              height: "40px",
              backgroundColor: "#ddd",
            }}
          >
            Receiveable Amount
          </Table.HeaderCell>
          <Table.HeaderCell
            width={1}
            style={{ height: "40px", backgroundColor: "#ddd" }}
          ></Table.HeaderCell>
        </Table.Row>

        <Table.Body>
          {payments.map((payment) => (
            <Table.Row>
              <Table.Cell style={{ textAlign: "center" }}>
                {payment.trans_date}
              </Table.Cell>
              <Table.Cell>
                <div style={{ whiteSpace: "pre-line" }}>
                  {payment.description}
                  <br />

                  <select
                    id={"entry_type" + payment.id}
                    onChange={() => this.projectUpdate(payment.id)}
                  >
                    <option value="">Select option</option>
                    <option
                      value="local"
                      selected={
                        payment.entry_type === "local" ? "selected" : ""
                      }
                    >
                      Local
                    </option>
                    <option
                      value="general"
                      selected={
                        payment.entry_type === "general" ? "selected" : ""
                      }
                    >
                      General
                    </option>
                  </select>
                </div>
              </Table.Cell>
              <Table.Cell>{payment.daily_hour}</Table.Cell>
              <Table.Cell>{payment.rate}</Table.Cell>
              <Table.Cell>{payment.amount}</Table.Cell>
              <Table.Cell>{payment.material_expense}</Table.Cell>
              <Table.Cell>{payment.total_expense}</Table.Cell>
              <Table.Cell>{payment.running_invoices}</Table.Cell>
              <Table.Cell style={{ textAlign: "center" }}>
                {payment.debit}
              </Table.Cell>

              <Table.Cell style={{ textAlign: "center" }}>
                {payment.credit}
              </Table.Cell>

              <Table.Cell style={{ textAlign: "center" }}>
                {/* {payment.receiveable_amount} */}
                {/* {payment.credit > 0 ?
                  (receiveable = parseFloat(receiveable) + parseFloat(payment.credit)).toFixed(2) : receiveable.toFixed(2)
                }
                {payment.debit > 0 ?
                  (receiveable = parseFloat(receiveable) - parseFloat(payment.debit)).toFixed(2) : receiveable.toFixed(2)
                } */}

                {payment.credit > 0
                  ? Math.round(
                      (receiveable = receiveable + parseFloat(payment.credit)),
                      2
                    )
                  : payment.debit > 0
                  ? Math.round(
                      (receiveable = receiveable - parseFloat(payment.debit)),
                      2
                    )
                  : Math.round(receiveable, 2)}

                {/* {payment.debit > 0
                  ? Math.round((receiveable = receiveable - parseFloat(payment.debit)), 2) :
                  ""} */}
              </Table.Cell>

              {payment.project_cost_id == 0 || payment.project_cost_id == "" ? (
                <Table.Cell style={{ backgroundColor: "red", color: "white" }}>
                  <Link to={url + payment.id} className="ui">
                    <Icon name="plus" color="blue" className="clickable" />
                  </Link>
                </Table.Cell>
              ) : payment.document != "" ? (
                <Table.Cell style={{ color: "white", textAlign: "center" }}>
                  <a
                    style={{
                      color: "white",
                      backgroundColor: "green",
                      paddingLeft: "14px",
                      paddinRight: "14px",
                      height: "8px",
                    }}
                    target="_blank"
                    href={
                      process.env.REACT_APP_BACKEND_URL +
                      "/storage/" +
                      payment.document
                    }
                  >
                    &nbsp;
                    {/* <Icon name="download" color="white" className="clickable" /> */}
                  </a>
                  <Link to={url + payment.id} className="ui">
                    <Icon name="edit" color="blue" className="clickable" />
                  </Link>
                </Table.Cell>
              ) : (
                <Table.Cell style={{ textAlign: "center" }}>
                  {/* {auth.getCurrentUser().email === "company-unblocker@gondalgroup.ae" && ( */}
                  <Link
                    to={url + payment.id}
                    className="ui"
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      paddingLeft: "14px",
                      paddinRight: "14px",
                      height: "8px",
                    }}
                  >
                    &nbsp;
                  </Link>
                  {/* )} */}
                </Table.Cell>
              )}

              <Table.Cell>
                {auth.getCurrentUser().email ===
                  "client-unblocker@gondalgroup.ae" && (
                  <div>
                    <Icon
                      name="trash"
                      color="red"
                      className="clickable"
                      onClick={() => onDelete(payment)}
                    />

                    <Icon
                      name="edit"
                      color="blue"
                      className="clickable"
                      onClick={() => onUpdate(payment)}
                    />
                  </div>
                )}
              </Table.Cell>
            </Table.Row>
          ))}

          <Table.Row>
            <Table.Cell></Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell>
              <b>{totalDailyHours}</b>
            </Table.Cell>
            <Table.Cell></Table.Cell>
            <Table.Cell>
              <b>{totalAmount}</b>
            </Table.Cell>
            <Table.Cell>
              <b>{tME}</b>
            </Table.Cell>
            <Table.Cell>
              <b>{tE}</b>
            </Table.Cell>
            <Table.Cell>
              <b>{tR}</b>
            </Table.Cell>
            <Table.Cell style={{ textAlign: "center" }}>
              <b>{totalDebit}</b>
            </Table.Cell>
            <Table.Cell style={{ textAlign: "center" }}>
              <b>{totalCredit /*tR*/}</b>
            </Table.Cell>
            <Table.Cell style={{ textAlign: "center" }}>
              <b>{parseFloat(totalCredit - totalDebit).toFixed(2)}</b>
            </Table.Cell>
            <Table.Cell></Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default LedgerProjectNetBalance;
